module.exports = __webpack_public_path__ + "img/tuurro.t6.rb.b6cf8058.png";